{
	"type": "fill",
	"minzoom": 11,
	"filter": ["==", ["geometry-type"], "Polygon"],
	"paint": { "fill-color": "#ffd200", "fill-opacity": 0.25, "fill-outline-color": "#b38f00" }
}
